

import React, { memo, useMemo } from 'react';

import { getOutputVersionSummary } from '@shootsta/addons-summarizer';
import BasicAddonsList from '../BasicAddonsList/BasicAddonsList';
import '../../styles/_addons-list.scss';











function VersionAddonsList({
  videoOutput,
  addonsSelector,
  noAddonsMessage,
  isAddonDescriptionWrapped,
  versionNumber,
  onChangeAddonStatus,
  shouldShowActions = false
}) {
  const outputVersionSummary = useMemo(
    () => getOutputVersionSummary(videoOutput, addonsSelector, versionNumber),
    [videoOutput, addonsSelector, versionNumber]
  );

  const addonsList = outputVersionSummary?.addonsList || [];

  return (
    <BasicAddonsList
      addonsList={addonsList}
      noAddonsMessage={noAddonsMessage}
      isAddonDescriptionWrapped={isAddonDescriptionWrapped}
      onChangeAddonStatus={onChangeAddonStatus}
      shouldShowActions={shouldShowActions} />);


}

export default memo(VersionAddonsList);